/**
 * Created by asiulik on 22.03.2018.
 */

define(['jquery', 'lodash', 'eventEmitter/EventEmitter', '../../utils'], function($, _, EventEmitter, Utils){

    var $window = $(window);

    var sectionHeaderConfig = {
        triggerAttr: 'data-section-header-id',
        triggerSelector: '[data-section-header-id]'
    };

    function SectionHeader(){}

    SectionHeader.prototype.init = function(){

        this.$sectionHeader = $('#sectionHeader');
        if(!this.$sectionHeader.length) return;

        this.$sectionHeaderTriggers = $(sectionHeaderConfig.triggerSelector);
        this.$sections = this.$sectionHeaderTriggers.map(function(index, sectionLink){

            var $sectionLink = $(sectionLink);
            var $section = $('#' + $sectionLink.attr(sectionHeaderConfig.triggerAttr))

            if(!$section.length) return;

            return $section;

        });

        this.bindEvents();

    };

    SectionHeader.prototype.bindEvents = function(){

        var _this = this;

        this.$sectionHeaderTriggers.on({
            click: function(e){

                e.preventDefault();
                var $section = $('#' + $(this).attr(sectionHeaderConfig.triggerAttr));

                if($section && $section.length) {
                    _this.scrollToSection($section);
                    $('.subheader').removeClass('subheader--opened');
                }
            }
        });

        this.lazyScroll = _.debounce(function(){

            _this.setActiveSection();

        }, 100);

        $window.on('scroll.sectionHeader', this.lazyScroll.bind(this));


    };

    SectionHeader.prototype.setActiveSection = function(){

        [].forEach.call(this.$sections, function($section){

            var isSectionActive = isActiveSection($section, $window.scrollTop());

        })

    };

    SectionHeader.prototype.scrollToSection = function($section){

        Utils.scrollPositionAnimate(calculateSectionOffset($section), 400);

    };

    SectionHeader.prototype.reload = function(){

        $window.off('scroll.sectionHeader');

    };

    function isActiveSection($section, scrollTop){

    }

    function calculateSectionOffset($section){
        return $section.offset().top - $('#p__header').height() - $('#sectionHeader').height() - 20
    }

    return SectionHeader;

});



// WEBPACK FOOTER //
// ./Private/Scripts/modules/section/sectionHeader.js